<!-- //
动态表单编辑
@auth xuyd
@date 2024-05-01
//-->
<template>
  <div class="flex-column">
    <div :style="{'max-height': maxHeight + 'px', 'overflow-x': 'auto'}">
      <el-table
          ref="refCompTableEditMode"
          class="table-edit-mode"
          size="mini"
          :data="list"
          :row-key="rowKey">
        <el-table-column v-if="dragSortable" header-align="center" label="" width="30" align="center">
          <template slot-scope="{row}">
            <span class="dragSortableHandle iconfont iconfont-list" style="cursor: move"></span>
          </template>
        </el-table-column>
        <template v-for="(cellName, index) in metas">
          <el-table-column header-align="left" align="left" :min-width="40" :prop="cellName" :key="index">
            <template slot="header" slot-scope="scope">
<!--              <div class="flex-row flex-valign-center">-->
                <span>{{ cellName }}</span>
<!--                <el-input :v-model="cellName" size="mini" style="width: 100%" @change="handleTitleChange(scope.$index, cellName, cellName)" />-->
<!--              </div>-->
            </template>
            <template slot-scope="{row}">
              <el-input size="mini" v-model="row[cellName]" style="width: 100%" @change="handleChange" />
            </template>
          </el-table-column>
        </template>

        <el-table-column header-align="center" label="" width="25" align="center">
          <template slot-scope="{$index}">
            <el-button size="mini" type="text" @click="handleDelete($index)">
              <el-icon class="el-icon-remove-outline" />
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-button type="text" icon="el-icon-circle-plus" @click="handleAdd">新增行</el-button>
    </div>
  </div>
</template>

<script>
import Sortable from 'sortablejs'
import variables from '../../assets/css/variables.less'

export default {
  name: 'CompTableEditMode',
  components: {},
  data() {
    return {
      list: this.value,
    }
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    dragSortable: {// 是否可以拖动排序
      type: Boolean,
      default: false
    },
    rowKey: {// 定义的行号，当拖动排序等操作需要
      type: String,
      default: 'id'
    },
    maxHeight: {
      type: Number,
      default: 300
    },
    metas: {
      type: Array,
      default: () => {
        return [] // {prop: '', label: ''}
      }
    },
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    value: {
      handler(val) {
        // console.log("-----watch value------->", val);
        if (val && val.length > 0) {
          this.list = val;
        } else {
          this.list = [this.initData()];
        }
        this.handleChange();
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.dragSortable) {
        this.initSortable();
      }
    });
  },
  methods: {
    initSortable() {
      console.log("初始化排序组件");
      // const elTbody = this.$el.querySelectorAll('.t-body')[0];
      let elTable = this.$refs.refCompTableEditMode.$el;
      const elTbody = elTable.querySelectorAll(".el-table__body-wrapper > table > tbody")[0];
      Sortable.create(elTbody, {
        animation: 150, // 动画
        // sort: true,
        handle: '.dragSortableHandle',
        onEnd: (evt) => {
          // console.log("000000000000000>", evt);
          const curRow = this.list.splice(evt.oldIndex, 1)[0];
          this.list.splice(evt.newIndex, 0, curRow);
          this.handleChange();
        },
      });
    },

    initData() {
      let row = {};
      row.id = this.$util.UUID();
      this.metas.forEach(item => {
        row[item] = null;
      });
      return row;
    },

    /**
     * 新增
     */
    handleAdd() {
      this.list = this.list || [];
      let index = this.list.length - 1;
      this.list.splice(index + 1, 0, this.initData());
      this.handleChange();
    },

    /**
     * 删除
     * @param index
     */
    handleDelete(index) {
      this.list.splice(index, 1);
      if (this.list.length <= 0) {
        this.list = [this.initData()];
      }
      this.handleChange();
    },

    handleChange(val) {
      this.$emit('change', this.list);
    },
    handleTitleChange(val) {
      console.log("----->", val)
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/variables.less';

.tableEditMode {
  padding: 5px;
  font-size: 12px;
  font-weight: 300;
  border: 1px solid @dv_form_input_border;

  .th-cell,
  .cell {
    height: 24px;
    line-height: 24px;
    border: 1px solid @dv_form_input_border;
  }

  .th-cell {
    color: @dv_form_label_color;
    background-color: @dv_background_fe;
  }

  .cell {
    background-color: @dv_background_bg;
  }

  .cell:hover {
    background-color: @mi-color;
  }

  .cell:focus {
    border-color: @dv_active_background_color;
  }

  :deep(.el-input__inner) {
    width: 100%;
    height: 100%;
    color: @dv_form_input_color;
    background-color: transparent;
    border-width: 0 !important;
    border-radius: 0;
  }

  .move {
    border: 1px solid @dv_form_input_border;
  }
}

.table-edit-mode {
  background-color: transparent;
}
</style>
